export default __webpack_public_path__ + "static/media/resend_icon_white_bordered.f782f069.svg";